unit BaseResponse;
{

/* Initial. */

}
interface

uses
  JS, WEBLib.Dialogs,
  ResultType, TranslationType;

type
  TBaseResponse = class
  private
    fResult: TResultType;
    fTranslation: TTranslationType;
  public
    property Result: TResultType read fResult;
    property Translation: TTranslationType read fTranslation;
    constructor Create(const String_JSON: String);
    destructor Destroy;
  end;

implementation

constructor TBaseResponse.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  JSObject_Type := TJSJSON.parseObject(String_JSON);

  fResult := TResultType.Create(TJSJSON.stringify(JSObject_Type['result']));
  fTranslation := TTranslationType.Create(TJSJSON.stringify(JSObject_Type['translation']));
end;

destructor TBaseResponse.Destroy;
begin
  fResult.Free;
  fTranslation.Free;
end;

end.
